import React from 'react';
import { HolidayFilters } from '../../../../app/models/Holiday';
import ButtonSearchFilter from '../../../../components/buttons/ButtonSearchFilter';

type Props = {
    filter: HolidayFilters;
    setFilter: (filter: HolidayFilters) => void;
    onSearch: () => void;
};

const ShiftFilter = ({ filter, setFilter, onSearch }: Props) => {
    const handlerInputFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value
        });
    };

    return (
        <div className="row">
            <div className="row">
                <div className="row">
                    <div className="col-md-auto">
                        <div className="mb-3">
                            <label className="font-size-10 mb-1" htmlFor="issue_date_first">
                                Nombre del turno
                            </label>
                            <input
                                title="Nombre del feriado"
                                type="text"
                                id="name"
                                name="name"
                                className="form-control form-control-sm"
                                value={filter.name}
                                onChange={(e) => handlerInputFilter(e)}
                            />
                        </div>
                    </div>
                    <div className='col-md-auto'>
                        <div style={{marginTop: '22px'}}>
                            <ButtonSearchFilter callbackSearch={onSearch}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ShiftFilter;
